import { useEffect, useRef } from 'react';
import { useMatch } from 'react-router-dom';

import { useChatContext } from '@sayyesschool/frontend/features/chat';
import ChatFrame from '@sayyesschool/frontend/features/chat/components/chat-frame';
import cn from '@sayyesschool/frontend/utils/classnames';

import styles from './Chat.module.scss';

export default function Chat() {
    const { frameRef, reset } = useChatContext();
    const isChatPage = Boolean(useMatch('/chat/*'));
    const wasChatPageRef = useRef(isChatPage);

    useEffect(() => {
        if (wasChatPageRef.current && !isChatPage) reset();

        wasChatPageRef.current = isChatPage;
    }, [isChatPage, reset]);

    return (
        <ChatFrame
            ref={frameRef}
            className={cn(!isChatPage && styles.hidden)}
        />
    );
}